import React from "react";
// import "./deleteChnnelConfir.css";
import axios from "../../../../axios";

function SaveChangesConfirm({
  editingAllMembersDetails,
  deletingAllMembersDetails,
  setConfirm,
  setIsMemberUpdated,
  isMemberUpdated,
  community,
}) {
  const { deletingStudents, deletingTeachers, deletingGroups, deletingAdmins } =
    deletingAllMembersDetails;
  let teacher_id = JSON.parse(localStorage.getItem("Teacher_id"));

  const handleSaveChanges = async () => {
    setIsMemberUpdated(!isMemberUpdated);
    try {
      let editingRes;
      let deletingRes;
      if (editingAllMembersDetails && editingAllMembersDetails.length > 0) {
        editingRes = await axios.put(
          `/community/${community.id}/updateMemberRole`,
          {
            user_id: teacher_id,
            members: editingAllMembersDetails,
          }
        );
      }
      if (
        deletingStudents.length > 0 ||
        deletingTeachers.length > 0 ||
        deletingGroups.length > 0 ||
        deletingAdmins.length > 0
      ) {
        deletingRes = await axios.delete(
          `/community/removeMember/${community.id}`,
          {
            data: {
              user_id: teacher_id,
              members: [
                { groups: deletingGroups },
                { teachers: deletingTeachers },
                { students: deletingStudents },
                { admins: deletingAdmins },
              ],
            },
          }
        );
      }
      setIsMemberUpdated(!isMemberUpdated);
      (editingRes || deletingRes) && window.location.reload();
    } catch (error) {
      setIsMemberUpdated(!isMemberUpdated);
      console.log(error);
    }
  };
  return (
    <>
      <div className=" delete_channel_transprant_body ">
        <img
          src="/images/cross-circle3.svg"
          className=" delete_channel_close_btn"
          alt=""
          onClick={(e) => setConfirm(false)}
        />
        <div className=" p-3 d-flex align-items-center justify-content-center flex-column delete_channel_container shadow">
          <span className="mb-4">
            Are you sure you want to proceed with these changes?
          </span>
          <div
            style={{ position: "relative" }}
            className="col-12 p-0 mt-4 gap-3 flex-wrap d-flex justify-content-center "
          >
            {isMemberUpdated && (
              <img
                className="on_button_spinner"
                src="/gif/White_loader.gif"
                alt=""
              />
            )}
            <button
              className="btn btn-danger col-sm-5  delete_btn"
              onClick={handleSaveChanges}
              disabled={isMemberUpdated}
            >
              Yes
            </button>
            <button
              className="btn btn-danger col-sm-5 delete_btn no"
              autoFocus
              onClick={(e) => setConfirm(false)}
              disabled={isMemberUpdated}
            >
              No
            </button>
          </div>
        </div>
      </div>
    </>
  );
}

export default SaveChangesConfirm;
